import React from "react";
import "./Introduction.css";
import { Stack } from "react-bootstrap";
import { map } from "lodash";

export const Introduction = ({ data }) => {
  const formattedHeading = data.head
    ?.toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
     .replace(/\bDmc\b/g, "DMC")
    .replace(/\bB2b\b/g, "B2B");
   

  return (
    <>
      <div className="introduction Extramargin standard-padding">
        <Stack>
          <p className="subheading mb-2">{data.title}</p>

          <h1 className="heading mb-4">{formattedHeading}</h1>

          {map(data.text, (text, index) => (
            <p key={index} className="text">
              {text}
            </p>
          ))}
        </Stack>
      </div>
    </>
  );
};
